import { useCartMutationVariables } from "@/core/api/graphql/cart/composables";
import { useMutation } from "@/core/api/graphql/composables";
import { SetWantsProformaInvoiceDocument } from "@/core/api/graphql/types";
import type { CartIdFragment, CartExtension } from "@/core/api/graphql/types";
import type { MaybeRef } from "vue";

export function useSetWantsProformaInvoiceMutation(cart?: MaybeRef<CartIdFragment | undefined>) {
  return useMutation(SetWantsProformaInvoiceDocument, useCartMutationVariables(cart));
}

/** @deprecated Use {@link useSetWantsProformaInvoiceMutation} instead. */
export async function setWantsProformaInvoice(wantsProformaInvoiceTL: boolean): Promise<CartExtension> {
  const { mutate } = useSetWantsProformaInvoiceMutation();
  const result = await mutate({ command: { wantsProformaInvoiceTL } });
  return result!.data!.setWantsProformaInvoice as CartExtension;
}
